import { render, staticRenderFns } from "./YTModal.vue?vue&type=template&id=4ce00f70&"
import script from "./YTModal.vue?vue&type=script&lang=js&"
export * from "./YTModal.vue?vue&type=script&lang=js&"
import style0 from "./YTModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports